import { UntypedFormGroup } from "@angular/forms";
import { ValidationResult } from "src/app/ui/models/domains/validator/validation-result";
import "moment/locale/pt-br";
import moment from 'moment';
import { SocialNumber } from "src/app/ui/models/domains/pbm/social-number.model";

export class SaveBeneficiaryValidator {
  public validationResult = new ValidationResult();

  constructor(private registrationBeneficiaryForm: UntypedFormGroup) {}

  getValidationResult(): ValidationResult {
    return this.validationResult;
  }

  validate(): ValidationResult {
    const name = this.registrationBeneficiaryForm.get("name").value;
    const socialNumber = this.registrationBeneficiaryForm.get("socialNumber").value;
    const admissionDate = this.registrationBeneficiaryForm.get("admissionDate").value;
    const birthDate = this.registrationBeneficiaryForm.get("birthDate").value;
    const gender = this.registrationBeneficiaryForm.get("gender").value;
    const maritalStatus = this.registrationBeneficiaryForm.get("maritalStatus").value;
    const email = this.registrationBeneficiaryForm.get("email").value;
    const region = this.registrationBeneficiaryForm.get("region").value;
    const city = this.registrationBeneficiaryForm.get("city").value;
    const district = this.registrationBeneficiaryForm.get("district").value;
    const needValidateEmail = this.registrationBeneficiaryForm.get("needValidateEmail").value;
    const enableDelivery = this.registrationBeneficiaryForm.get("enableDelivery").value;
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!name) {
      this.validationResult.addErrorMessage("É necessário inserir um nome");
    } else if (!socialNumber) {
      this.validationResult.addErrorMessage("É necessário inserir um CPF");
    } else if (!SocialNumber.isValid(socialNumber)) {
      this.validationResult.addErrorMessage("CPF inválido");
    } else if (gender === null) {
      this.validationResult.addErrorMessage("É necessário selecionar um Sexo");
    } else if (maritalStatus === null) {
      this.validationResult.addErrorMessage("É necessário selecionar um Estado Civil");
    } else if (!region) {
      this.validationResult.addErrorMessage("É necessário inserir um Estado");
    } else if (!city) {
      this.validationResult.addErrorMessage("É necessário inserir uma Cidade");
    } else if (!district) {
      this.validationResult.addErrorMessage("É necessário inserir um Bairro");
    } else if (!!admissionDate && !moment(admissionDate, "DDMMYYYY").isValid()) {
      this.validationResult.addErrorMessage("Data de admissão inválida");
    } else if (!!birthDate && !moment(birthDate, "DDMMYYYY").isValid()) {
      this.validationResult.addErrorMessage("Data de nascimento inválida");
    } else if (needValidateEmail && !email) {
      this.validationResult.addErrorMessage("É necessário inserir um E-mail");
    } else if (email && !emailRegex.test(email.toLowerCase())) {
      this.validationResult.addErrorMessage("E-mail inválido");
    }
    return this.validationResult;
  }

  public validateAdmissionDate(): string {
    if (!this.registrationBeneficiaryForm.get("admissionDate").value) {
      return "";
    } else {
      return this.registrationBeneficiaryForm.get("admissionDate").value;
    }
  }

  public validateBirthDate(): string {
    if (!this.registrationBeneficiaryForm.get("birthDate").value) {
      return "";
    } else {
      return this.registrationBeneficiaryForm.get("birthDate").value;
    }
  }

  public validateTelephone(): string {
    if (!this.registrationBeneficiaryForm.get("telephone").value) {
      return "";
    } else {
      return this.registrationBeneficiaryForm.get("telephone").value;
    }
  }

  public validateMobile(): string {
    if (!this.registrationBeneficiaryForm.get("mobile").value) {
      return "";
    } else {
      return this.registrationBeneficiaryForm.get("mobile").value;
    }
  }

  public validateZipCode(): string {
    if (!this.registrationBeneficiaryForm.get("zipCode").value) {
      return "";
    } else {
      return this.registrationBeneficiaryForm.get("zipCode").value;
    }
  }
}
